import './index.scss';

export default class Accordion {
    constructor(root) {
        this.root = root;

        this.items = this.root.querySelectorAll('.accordion-item');
        this.items.forEach((item) => { this.initItem(item); });

        window.addEventListener('resize', this.resize.bind(this));
    }

    initItem(item) {
        const link = item.querySelector('.accordion-item__link');
        const pane = item.querySelector('.accordion-item__pane');

        link.addEventListener('click', (event) => {
            event.preventDefault();

            if (item.classList.contains('opened')) {
                item.classList.remove('opened');
                pane.style.maxHeight = null;
            } else {
                // this.closeAll();

                item.classList.add('opened');
                pane.style.maxHeight = pane.scrollHeight + 'px';
            }
        });
    }

    closeAll() {
        this.items.forEach((item) => {
            const pane = item.querySelector('.accordion-item__pane');

            if (item.classList.contains('opened')) {
                item.classList.remove('opened');
                pane.style.maxHeight = null;
            }
        });
    }

    resize() {
        this.items.forEach((item) => {
            const pane = item.querySelector('.accordion-item__pane');

            if (item.classList.contains('opened')) {
                pane.style.maxHeight = pane.scrollHeight + 'px';
            }
        });
    }
}

window.app.run(() => {
    document.querySelectorAll('.accordion').forEach((node) => {
        new Accordion(node);
    });
});
